import { render, staticRenderFns } from "./WindingSection.vue?vue&type=template&id=8bb98e02&scoped=true&"
import script from "./WindingSection.vue?vue&type=script&lang=js&"
export * from "./WindingSection.vue?vue&type=script&lang=js&"
import style0 from "./WindingSection.vue?vue&type=style&index=0&id=8bb98e02&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb98e02",
  null
  
)

export default component.exports